module.exports = __webpack_public_path__ + "static/tips-new.3b4b5442.png";